import ABTestRootOutlet from '@app-studio-web/ui/components/ABTestRootOutlet'
import createAccountRoutes from '@app-studio-web/ui/pages/account/accountRoutes'
import checkoutRoutes from '@app-studio-web/ui/pages/checkout/checkoutRoutes'
import ErrorPage from '@app-studio-web/ui/pages/ErrorPage'
import helpCenterRoutes from '@app-studio-web/ui/pages/helpCenter/helpCenterRoutes'
import PreparingPage from '@app-studio-web/ui/pages/signUp/PreparingPage'
import signUpRoutes from '@app-studio-web/ui/pages/signUp/signUpRoutes'
import { getABTestConfig } from '@config/abTestConfig'
import { Navigate, Outlet } from 'react-router-dom'
import { saveOnboardingAnswers } from '../actions/saveOnboardingAnswers'
import alzheimerOnboardingRoutes from './alzheimer/onboarding/routes'
import OnboardingOutlet from './baseline/onboarding/OnboardingOutlet'
import baselineOnboardingRoutes from './baseline/onboarding/routes'
import LandingPage from './LandingPage'
import v1OnboardingRoutes from './v1/onboarding/routes'

const abTestConfig = getABTestConfig()

const routes = [
  {
    element: <ABTestRootOutlet abTestConfig={abTestConfig || undefined} />,
    errorElement: <ErrorPage />,
    path: '/',
    children: [
      {
        element: <LandingPage />,
        index: true,
      },
      {
        element: <Outlet />,
        path: 'account',
        children: createAccountRoutes(),
      },
      {
        element: <Outlet />,
        path: 'checkout',
        children: checkoutRoutes,
      },
      {
        element: <Outlet />,
        path: 'help-center',
        children: helpCenterRoutes,
      },
      {
        element: <OnboardingOutlet />,
        path: 'onboarding',
        children: [...baselineOnboardingRoutes, ...v1OnboardingRoutes],
      },
      {
        element: <Outlet />,
        path: 'alzheimer',
        children: alzheimerOnboardingRoutes,
      },
      {
        element: <Outlet />,
        path: 'sign-up',
        children: signUpRoutes.map((route) => {
          if (route.path === 'preparing') {
            return {
              ...route,
              element: <PreparingPage onPrepare={saveOnboardingAnswers} />,
            }
          }
          return route
        }),
      },
      {
        element: <Navigate to="/onboarding" replace />,
        path: '*',
      },
    ],
  },
]

export default routes
